// import utils
import { t } from 'i18next';
import * as yup from 'yup';

const optionalNumber = () =>
  yup
    .number()
    .transform((value, original) =>
      original === '' || original === null ? null : value
    )
    .nullable()
    .notRequired()
    .typeError(t('enterAValidNumericValue'));

export const kmSchema = yup.object({
  finEmpKmManual: optionalNumber(),
  finEmpTravelExpensesManual: optionalNumber().positive(
    t('enterAValidPositiveNumericValue')
  )
});
